export interface GlossaryTerm {
  slug: string
  title: string
  abbreviation?: string
  category: string
  definition: string
  content: string
}

export interface GlossaryCategory {
  slug: string
  name: string
}

export const glossaryCategories: GlossaryCategory[] = [
  { slug: 'acquisition', name: 'Acquisition' },
  { slug: 'agencies', name: 'Agencies' },
  { slug: 'business', name: 'Business' },
  { slug: 'business-development', name: 'Business Development' },
  { slug: 'classification', name: 'Classification' },
  { slug: 'contracts', name: 'Contracts' },
  { slug: 'evaluation', name: 'Evaluation' },
  { slug: 'finance', name: 'Finance' },
  { slug: 'management', name: 'Management' },
  { slug: 'personnel', name: 'Personnel' },
  { slug: 'products', name: 'Products' },
  { slug: 'programs', name: 'Programs' },
  { slug: 'registration', name: 'Registration' },
  { slug: 'regulations', name: 'Regulations' },
  { slug: 'security', name: 'Security' },
  { slug: 'solicitations', name: 'Solicitations' },
]

export function getCategoryBySlug(slug: string): GlossaryCategory | undefined {
  return glossaryCategories.find((cat) => cat.slug === slug)
}
